"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const Colors_1 = __importDefault(require("../../../assets/colors/Colors"));
const images_1 = require("../../../assets/images");
const components_1 = require("../../../components");
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const constants_1 = __importDefault(require("../../../constants/constants"));
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const AsyncStorage_1 = __importDefault(require("../../../utils/AsyncStorage"));
const scale_1 = require("../../../utils/scale");
const styles_1 = __importDefault(require("./styles"));
const Tutorial = () => {
    const onPrimaryButtonPress = async () => {
        await AsyncStorage_1.default.set(constants_1.default.IS_COMPLETED_TUTORIAL, 1);
        (0, rootNavigation_1.reset)({ index: 0, routeName: Routes_1.default.MAINTABBAR });
    };
    const onHeaderRightButtonPress = async () => {
        await AsyncStorage_1.default.set(constants_1.default.IS_COMPLETED_TUTORIAL, 0);
        (0, rootNavigation_1.reset)({ index: 0, routeName: Routes_1.default.MAINTABBAR });
    };
    return (react_1.default.createElement(react_native_1.View, { style: { flex: 1, backgroundColor: '#F7F7F7', } },
        react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: "center" }, title: "チュートリアル", styleContainer: {
                backgroundColor: Colors_1.default.white,
                zIndex: 1,
            }, rightIcon: react_1.default.createElement(CustomText_1.default, { style: {
                    fontSize: (0, scale_1.moderateScale)(12),
                    lineHeight: (0, scale_1.moderateScale)(18),
                    fontWeight: "300",
                    color: "#007AFF",
                } }, "\u30B9\u30AD\u30C3\u30D7"), onRightPress: onHeaderRightButtonPress }),
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.container },
            react_1.default.createElement(react_native_1.Image, { source: images_1.images.Tutorial, style: {
                    marginTop: (0, scale_1.scale)(24),
                    height: (0, scale_1.scale)(257),
                    width: (0, scale_1.scale)(343),
                } }),
            react_1.default.createElement(CustomText_1.default, { style: {
                    fontSize: (0, scale_1.moderateScale)(15),
                    lineHeight: (0, scale_1.moderateScale)(22.5),
                    color: '#292A33',
                    marginTop: (0, scale_1.scale)(16),
                } }, `現在「投資の先輩」はβ版として公開中です。\n正式リリースに際しても、皆様が入力されたデータは引き継がれますので、ご安心ください。\nβ版のため、使いづらい点や不具合が生じる可能性もございますが、どうかご理解いただけますと幸いです。`),
            react_1.default.createElement(components_1.LinearButton, { containerStyle: { marginTop: (0, scale_1.scale)(32) }, fontWeight: "600", title: "\u3055\u3063\u305D\u304F\u306F\u3058\u3081\u308B", onPress: onPrimaryButtonPress }))));
};
exports.default = Tutorial;
